import MapEditDialog from '../MapEditDialog/MapEditDialog'
import PartiallyDuplicateMapDialog from 'features/common/ui/Map/PartiallyDuplicateMapDialog'
import { Map } from 'features/maps/types'
import { HardQuotaModalController } from 'features/quotas/ui/WouldExceedQuotaDialog'
import MapsHardQuotaModal from '../MapsHardQuotaModal'
import { QuotaUxTrigger } from 'features/hubspot/types'

interface MapCardDialogWrapperProps {
  map: Map
  isEditable: boolean
  openEdit: boolean
  openDuplicate: boolean
  handleCloseEdit: () => void
  handleCloseDuplicate: () => void
  handleCloseHardQuotaModal: () => void
  hardQuotaModalController: HardQuotaModalController
}

function MapCardDialogWrapper({
  map,
  isEditable,
  openDuplicate,
  openEdit,
  handleCloseDuplicate,
  handleCloseEdit,
  handleCloseHardQuotaModal,
  hardQuotaModalController
}: MapCardDialogWrapperProps) {
  return (
    <>
      <div onClick={(e) => e.stopPropagation()}>
        {map?.id && openDuplicate && (
          <PartiallyDuplicateMapDialog mapId={map?.id} isOpen={openDuplicate} onClose={handleCloseDuplicate} />
        )}
        {isEditable && openEdit && <MapEditDialog map={map} open={openEdit} onClose={handleCloseEdit} />}
        <MapsHardQuotaModal
          variant="duplicate"
          {...hardQuotaModalController.props}
          onCloseModal={handleCloseHardQuotaModal}
          quotaUxTrigger={QuotaUxTrigger.DuplicateMap}
        />
      </div>
    </>
  )
}

export default MapCardDialogWrapper
